import * as React from 'react';
import store from "../../storeWire";
import { system_notification } from "../../store/slice/system";
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

export function OpenQuoteTableHeader() {
    const [{ openQuoteList }, { }, { }] = useQuoteStore();
    const [_check_p] = useCheckAuthPermissions();
    const isDisabled = (openQuoteList !== undefined && Object.keys(openQuoteList) !== undefined && openQuoteList.count > 0) ? false : true;
    const openContactUsPopup = (val) => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: val != undefined ? val : false },
        }));
    };

    return (
        <>
            <div className="additional-word-wrap align-items-center border-0">
                <div className="ps5 d-flex align-items-center quote-tabs-links mb-0">
                    <p className="ps5 text-black-stone mb-0">My Open Quotes</p>
                    <a href={Quote.getQuoteListingRouteURL()} className='ms-1'>My Submitted Quotes</a>
                </div>
                <div className='text-end px-3 pt-4 quote-tabs-content'>
                    <button className={`bs5 btn btn-secondary w145 ${isDisabled === true ? 'disabled' : ''}`} data-toggle="modal" data-target="#clearquote-modal" disabled={isDisabled}
                        onClick={() => {
                            store.dispatch(system_notification({
                                name: 'ClearQuotePopup',
                                data: [],
                            }));
                        }}>CLEAR Quote</button>
                    <button className={`bs5 btn btn-primary w145 ms-2 ${isDisabled === true ? 'disabled' : ''}`} disabled={isDisabled} onClick={() => { 
                        _check_p('QT_BUY_NOW').status === false ? openContactUsPopup(true) : (window.location.href = Quote.getQuoteHeaderDetailRouteURL())
                    }}>CONTINUE</button>
            </div>
        </div>
        </>
    );

}
